import { CustomFormTypeEnum } from 'enums/CustomFormType';
import { FieldHookConfig, useField } from 'formik';
import { Entity } from 'types/common';
import { CustomFormPicker } from '../pickers/AutocompletePickers/CustomFormPicker';
import { IFieldProps } from './FormRender/IFormFieldSetting';

export const FormCustomFormPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> &
  IFieldProps & { formType: CustomFormTypeEnum }) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <CustomFormPicker
        name={props.name}
        filter={props.filter}
        formType={props.formType}
        placeholder={props.placeholder}
        label={label}
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onBlur={field?.onBlur}
        value={field.value}
        variant="filled"
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        info={props.info}
        disabled={props.disabled}
      />
    </>
  );
};
